module.exports = __webpack_public_path__ + "img/10_105.7fa68ae8.png";